module.exports = __webpack_public_path__ + "img/placeholder.7fd1bec6.jpg";